import React from 'react';
import { Box } from '@mui/material';
import { PAGE_TYPE } from '../../types/pages.type';

const MobileCardList = ({ cards, children, page }) => {
  // children is a render function: (card, idx) => ReactNode
  return (
    <Box sx={{ width: '100%', mt: 2, mb: page === PAGE_TYPE.ADMISSION || page === PAGE_TYPE.OVERALL ? 0 : 8 }}>
      {cards.map((card, idx) => (
        <Box
          key={card.id}
          sx={{
            width: '100%',
            mb: 2, // spacing between cards            
            boxShadow: 0,
            borderRadius: 2,
            background: 'transparent',
            p: 0,
          }}
        >
          {children(card, idx)}
        </Box>
      ))}
    </Box>
  );
};

export default MobileCardList; 